/* ============================================
   GhostShell — Premium Motion System
   Scroll Reveals, Interactions, Micro-animations
   ============================================ */

/* Global: respect prefers-reduced-motion everywhere */
var GS_REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ── Section Rendering API helpers ──────────────────────────────────────────
   Shared by the sticky cart bar and the shop filter tabs. Both re-render
   server-side markup so that PRICES ALWAYS COME FROM LIQUID'S `money` FILTER
   and are never assembled in JS. Nothing in this file may format currency. */

/* Locale-aware site root. On a localised market Shopify.routes.root is
   '/en-eu/' (always trailing-slashed), not '/'. Fetching a bare '/' would
   render sections in the wrong market and put the currency bug straight back.
   Falls back to '/' only if the global is somehow unavailable. */
function gsRoot() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
}

/* The ?sections= response wraps each section in its own
   <div id="shopify-section-{id}">. Assigning that straight into the existing
   host would nest a second wrapper and duplicate the element id, so unwrap it
   when present and fall back to the raw markup when it isn't. */
function gsSectionInner(html, sectionId) {
  var parsed = new DOMParser().parseFromString(html, 'text/html');
  var wrapper = parsed.getElementById('shopify-section-' + sectionId);
  return wrapper ? wrapper.innerHTML : html;
}

/* Marker classes: gs-js = JS is running; gs-anim = motion allowed.
   CSS keys enhanced states (e.g. image fade-in) off these so nothing
   is hidden when JS fails or the user prefers reduced motion. */
document.documentElement.classList.add('gs-js');
if (!GS_REDUCED_MOTION) document.documentElement.classList.add('gs-anim');

/* Image fade-in on load — no harsh pop-in. Marks images ready as they
   load; already-cached images are marked immediately. */
(function() {
  if (GS_REDUCED_MOTION) return;

  function markReady(img) { img.classList.add('gs-img-ready'); }

  function initImageFade() {
    document.querySelectorAll('.product-img, .gs-product-img, .gs-thumb img, .gs-cart-item-image img').forEach(function(img) {
      if (img.classList.contains('gs-img-ready')) return;
      if (img.complete && img.naturalWidth > 0) {
        markReady(img);
      } else {
        img.addEventListener('load', function() { markReady(img); }, { once: true });
        img.addEventListener('error', function() { markReady(img); }, { once: true });
        // Safety net: never leave an image invisible
        setTimeout(function() { markReady(img); }, 2500);
      }
    });
  }

  // Exposed so dynamically injected grids (filter tabs) can re-run it.
  window.gsInitImageFade = initImageFade;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageFade);
  } else {
    initImageFade();
  }
})();

/* Rebuild a responsive srcset for a Shopify CDN url.
   Needed because an <img> that already has a srcset resolves its source FROM the
   srcset — assigning a new src alone would leave the old picture on screen. */
window.gsSrcset = function(url) {
  if (!url || url.indexOf('cdn.shopify.com') === -1) return '';
  var join = url.indexOf('?') === -1 ? '?' : '&';
  var base = url.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, '');
  join = base.indexOf('?') === -1 ? '?' : '&';
  return [375, 550, 750, 1100, 1500].map(function(w) {
    return base + join + 'width=' + w + ' ' + w + 'w';
  }).join(', ');
};

/* Global: swap an image with a short cross-fade (GPU-friendly, opacity only) */
window.gsSwapImage = function(img, src) {
  if (!img) return;
  var nextSet = img.getAttribute('srcset') ? window.gsSrcset(src) : '';
  var applySrc = function() {
    if (nextSet) { img.setAttribute('srcset', nextSet); }
    img.src = src;
  };
  if (GS_REDUCED_MOTION || img.src === src) { applySrc(); return; }
  img.classList.add('gs-img-fading');
  var done = false;
  var swap = function() {
    if (done) return;
    done = true;
    var loader = new Image();
    loader.onload = function() {
      applySrc();
      requestAnimationFrame(function() { img.classList.remove('gs-img-fading'); });
    };
    loader.onerror = function() { img.classList.remove('gs-img-fading'); };
    loader.src = src;
  };
  img.addEventListener('transitionend', swap, { once: true });
  setTimeout(swap, 220); // fallback if transitionend never fires
};

document.addEventListener('DOMContentLoaded', () => {

  /* ============================================
     Scroll Progress Indicator
     ============================================ */
  function initScrollProgress() {
    // Reuse the static element from theme.liquid; only create one if missing.
    let progressEl = document.querySelector('.scroll-progress');
    if (!progressEl) {
      progressEl = document.createElement('div');
      progressEl.className = 'scroll-progress';
      document.body.prepend(progressEl);
    }

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        progressEl.style.width = progress + '%';
        ticking = false;
      });
    }, { passive: true });
  }
  initScrollProgress();

  /* ============================================
     Sticky Header State
     ============================================ */
  const header = document.querySelector('.header');
  let lastScrollY = window.pageYOffset;

  function updateHeader() {
    if (!header) return;
    const currentY = window.pageYOffset;

    if (currentY > 100) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  window.addEventListener('scroll', () => {
    requestAnimationFrame(updateHeader);
  }, { passive: true });

  /* ============================================
     Mobile Smart Header — hide on scroll down, show on scroll up
     ============================================ */
  (function() {
    if (window.innerWidth > 768) return;

    var mobileHeader = document.querySelector('.header');
    var lastScrollY = window.scrollY;
    var ticking = false;
    var scrollTimer = null;
    var headerVisible = true;

    function showHeader() {
      if (!headerVisible && mobileHeader) {
        mobileHeader.style.transform = 'translateY(0)';
        headerVisible = true;
      }
    }

    function hideHeader() {
      if (headerVisible && mobileHeader) {
        mobileHeader.style.transform = 'translateY(-100%)';
        headerVisible = false;
      }
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          var currentScrollY = window.scrollY;

          if (currentScrollY < 80) {
            showHeader();
            lastScrollY = currentScrollY;
            ticking = false;
            return;
          }

          if (currentScrollY > lastScrollY) {
            hideHeader();
          } else {
            showHeader();
          }

          lastScrollY = currentScrollY;
          ticking = false;

          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function() {
            showHeader();
          }, 1000);
        });
        ticking = true;
      }
    }, { passive: true });
  })();

  /* ============================================
     Scroll Reveal System
     ============================================ */
  const revealOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -80px 0px'
  };

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        revealObserver.unobserve(entry.target);
      }
    });
  }, revealOptions);

  if (GS_REDUCED_MOTION) {
    // No motion: mark everything visible immediately.
    document.querySelectorAll('section').forEach(section => {
      section.classList.add('reveal', 'active');
    });
  } else {
    // Observe sections for reveal
    document.querySelectorAll('section').forEach(section => {
      section.classList.add('reveal');
      revealObserver.observe(section);
    });

    // Observe cards and grid items
    document.querySelectorAll('.product-card, .value-card, .measure-card, .fit-card, .review-card, .trust-card, .cert-card, .community-stat').forEach(el => {
      el.classList.add('reveal-child');
    });
  }

  /* ============================================
     FAQ Accordion with Smooth Animation
     ============================================ */
  // FAQ: class-toggle only — CSS handles max-height via !important rules.
  // Single 'click' listener avoids the touchend+click double-fire bug on mobile.
  // aria-expanded is written on EVERY toggle, not just the clicked one: this is an
  // exclusive accordion, so opening one closes the rest and their buttons must say so.
  // The product-page FAQ shipped a static aria-expanded="false" that nothing updated,
  // which told a screen reader the panel was closed while it was visibly open.
  function gsSyncFaqState() {
    document.querySelectorAll('.faq-question').forEach(function(btn) {
      var parent = btn.closest('.faq-item');
      btn.setAttribute('aria-expanded', parent && parent.classList.contains('active') ? 'true' : 'false');
    });
  }

  document.querySelectorAll('.faq-question').forEach(function(question) {
    question.addEventListener('click', function(e) {
      e.stopPropagation();
      var item = this.closest('.faq-item');
      var isActive = item.classList.contains('active');
      // Close all
      document.querySelectorAll('.faq-item').forEach(function(i) {
        i.classList.remove('active');
      });
      // Open clicked if it was closed
      if (!isActive) {
        item.classList.add('active');
      }
      gsSyncFaqState();
    });
  });

  gsSyncFaqState();

  /* ============================================
     CE Armor Tech Points — Click/tap to toggle tooltip
     ============================================ */
  function initTechPoints() {
    var points = document.querySelectorAll('.gs-tech-point');
    if (!points.length) return;

    points.forEach(function(point) {
      point.style.cursor = 'pointer';
      point.style.pointerEvents = 'auto';

      function togglePoint(e) {
        e.stopPropagation();
        e.preventDefault();
        var isActive = point.classList.contains('active');
        points.forEach(function(p) { p.classList.remove('active'); });
        if (!isActive) point.classList.add('active');
      }

      point.addEventListener('click', togglePoint);
      point.addEventListener('touchend', togglePoint);
    });

    document.addEventListener('click', function() {
      points.forEach(function(p) { p.classList.remove('active'); });
    });
    document.addEventListener('touchend', function() {
      points.forEach(function(p) { p.classList.remove('active'); });
    });
  }
  initTechPoints();

  /* ============================================
     Animated Counter for Stats
     ============================================ */
  function animateCounter(element, target, suffix = '') {
    let current = 0;
    const increment = target / 50;
    const duration = 2000;
    const stepTime = duration / 50;

    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(timer);
      }

      if (target >= 1000) {
        element.textContent = Math.floor(current).toLocaleString() + suffix;
      } else if (target % 1 !== 0) {
        element.textContent = current.toFixed(1) + suffix;
      } else {
        element.textContent = Math.floor(current) + suffix;
      }
    }, stepTime);
  }

  // Observe stat numbers for counting animation (skipped for reduced motion —
  // the markup already contains the final value)
  if (!GS_REDUCED_MOTION) {
    const statObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const text = el.textContent.trim();
          // Anchored match: only animate purely numeric stats ("1,000+", "30").
          // Mixed text like "CE L2" must not be rewritten to just its digits.
          const match = text.match(/^([\d,]+)([+%★]*)$/);

          if (match) {
            const num = parseFloat(match[1].replace(/,/g, ''));
            const suffix = match[2] || '';
            animateCounter(el, num, suffix);
          }

          statObserver.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('.stat-number').forEach(el => {
      statObserver.observe(el);
    });
  }

  /* ============================================
     Button Magnetic Hover Effect (desktop pointers only)
     ============================================ */
  if (!GS_REDUCED_MOTION && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.btn').forEach(btn => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;

        btn.style.transform = `translate(${x * 0.1}px, ${y * 0.1}px)`;
      });

      btn.addEventListener('mouseleave', () => {
        btn.style.transform = 'translate(0, 0)';
      });
    });
  }

  /* ============================================
     Image Parallax on Scroll - REMOVED
     Scroll-linked image movement disabled for premium static feel
     ============================================ */

  /* ============================================
     Smooth Scroll for Anchor Links
     ============================================ */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const href = anchor.getAttribute('href');

      if (href !== '#' && href.length > 1) {
        const target = document.querySelector(href);

        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  /* ============================================
     Mobile Menu Toggle — fullscreen overlay
     open/close functions handle both click and touchend.
     The header.liquid inline script also adds click listeners;
     these run in addition without conflict.
     ============================================ */
  const mobileMenuBtn   = document.querySelector('.mobile-menu-btn');
  const mobileMenuEl    = document.getElementById('mobileMenu');
  const mobileMenuClose = document.getElementById('mobileMenuClose');

  function openMobileMenu() {
    if (!mobileMenuEl) return;
    mobileMenuEl.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (mobileMenuBtn) {
      const lines = mobileMenuBtn.querySelectorAll('.hamburger-line');
      lines[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
      lines[1].style.opacity   = '0';
      lines[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
    }
  }

  function closeMobileMenu() {
    if (!mobileMenuEl) return;
    mobileMenuEl.classList.remove('active');
    document.body.style.overflow = '';
    if (mobileMenuBtn) {
      const lines = mobileMenuBtn.querySelectorAll('.hamburger-line');
      lines[0].style.transform = 'none';
      lines[1].style.opacity   = '1';
      lines[2].style.transform = 'none';
    }
  }

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', openMobileMenu);
    mobileMenuBtn.addEventListener('touchend', (e) => {
      e.preventDefault();
      openMobileMenu();
    }, { passive: false });
  }

  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMobileMenu);
    mobileMenuClose.addEventListener('touchend', (e) => {
      e.preventDefault();
      closeMobileMenu();
    }, { passive: false });
  }

  if (mobileMenuEl) {
    mobileMenuEl.addEventListener('click', (e) => {
      if (e.target === mobileMenuEl) closeMobileMenu();
    });
  }

  /* ============================================
     Trust Item Stagger Animation
     ============================================ */
  const trustItems = document.querySelectorAll('.trust-item');
  trustItems.forEach((item, i) => {
    item.style.transitionDelay = `${i * 0.1}s`;
  });

  /* ============================================
     Cursor Glow Effect (Desktop Only)
     ============================================ */
  if (window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.product-card, .value-card, .measure-card').forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        card.style.setProperty('--mouse-x', `${x}px`);
        card.style.setProperty('--mouse-y', `${y}px`);
      });
    });
  }

  /* ============================================
     Contact Form Handling
     ============================================ */
  const contactForm = document.getElementById('contact-form');

  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(contactForm);
      const data = Object.fromEntries(formData);

      // Visual feedback - button state
      const submitBtn = contactForm.querySelector('button[type="submit"]');
      const originalText = submitBtn.innerHTML;

      submitBtn.disabled = true;
      submitBtn.innerHTML = `
        <svg class="spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:20px;height:20px;animation:spin 1s linear infinite">
          <circle cx="12" cy="12" r="10"/><path d="M12 2a10 10 0 0 1 10 10"/>
        </svg>
        Sending...
      `;

      // Simulate send (would connect to backend in production)
      setTimeout(() => {
        submitBtn.innerHTML = `
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:20px;height:20px;margin-right:8px">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          Message Sent
        `;
        submitBtn.style.background = 'var(--success)';

        setTimeout(() => {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
          submitBtn.style.background = '';
          contactForm.reset();
        }, 3000);
      }, 1500);
    });
  }

  /* ============================================
     Form Input Focus Effects
     ============================================ */
  document.querySelectorAll('.form-input, .form-textarea, .form-select').forEach(input => {
    const group = input.closest('.form-group');

    input.addEventListener('focus', () => {
      group.classList.add('focused');
    });

    input.addEventListener('blur', () => {
      group.classList.remove('focused');
    });
  });

  /* ============================================
     Section Background Parallax
     ============================================ */
  const parallaxSections = document.querySelectorAll('.contact-hero, .page-header');

  // rAF-throttled; skipped entirely for reduced motion or when unused.
  if (parallaxSections.length && !GS_REDUCED_MOTION) {
    let parallaxTicking = false;
    window.addEventListener('scroll', () => {
      if (parallaxTicking) return;
      parallaxTicking = true;
      requestAnimationFrame(() => {
        parallaxSections.forEach(section => {
          const rect = section.getBoundingClientRect();
          const speed = 0.05;

          if (rect.top < window.innerHeight && rect.bottom > 0) {
            const offset = (window.innerHeight - rect.top) * speed;
            section.style.backgroundPositionY = `${offset}px`;
          }
        });
        parallaxTicking = false;
      });
    }, { passive: true });
  }

  /* ============================================
     Stagger Animation for Grid Items
     ============================================ */
  function staggerAnimate(selector, options = {}) {
    const elements = document.querySelectorAll(selector);
    const delay = options.delay || 0.1;

    elements.forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = `opacity ${options.duration || 0.4}s ease, transform ${options.duration || 0.4}s ease`;
      el.style.transitionDelay = `${i * delay}s`;

      setTimeout(() => {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }, 100);
    });
  }

  // Apply stagger to support cards on scroll
  const supportObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        staggerAnimate('.support-card', { delay: 0.15, duration: 0.5 });
        supportObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('.support-promise').forEach(section => {
    supportObserver.observe(section);
  });

  // Motion system ready
});

/* ============================================
   Sticky Cart Bar — live cart state
   ============================================ */
(function() {
  /* The bar lives in the footer section GROUP, so its wrapper id is generated
     (sections--...__sticky_cart) and cannot be hardcoded. The section renders
     its own id into data-gs-sticky-cart; we read it from there. */
  function stickyEl() { return document.querySelector('[data-gs-sticky-cart]'); }

  /* The bar is re-rendered by the server rather than patched in JS.

     It used to fetch /cart.js and concatenate a hardcoded euro sign onto
     (total_price / 100). /cart.js
     returns presentment-currency cents but no formatted string, so that
     hardcoded symbol was pinned to whatever amount the market returned - the
     "395 zl becomes 395 EUR" regression. Asking the Section Rendering API for
     the section instead gets the price straight from Liquid's `money` filter,
     already converted and formatted for the active market.

     Replacing innerHTML is safe here: the bar holds no focusable state a
     shopper can be mid-interaction with (two links), and it is mobile-only. */
  function updateStickyCart() {
    var el = stickyEl();
    if (!el) return;
    var sectionId = el.getAttribute('data-gs-sticky-cart');
    var host = el.closest('.shopify-section');
    if (!sectionId || !host) return;

    /* Shopify.routes.root, not a bare '/': on a localised market the root is
       something like '/en-eu/', and requesting '/' would render the section in
       the WRONG market - reintroducing this exact bug through the back door. */
    fetch(gsRoot() + '?sections=' + encodeURIComponent(sectionId))
      .then(function(r) {
        if (!r.ok) throw new Error('sticky cart section render failed');
        return r.json();
      })
      .then(function(data) {
        var html = data[sectionId];
        if (!html) return;
        host.innerHTML = gsSectionInner(html, sectionId);
      })
      .catch(function() { /* silently fail — cart state is non-critical */ });
  }

  /* No DOMContentLoaded call: the section is already server-rendered with the
     correct cart state at first paint, so fetching on load would be a wasted
     request that re-renders identical markup. */
  document.addEventListener('cart:updated', updateStickyCart);
  setInterval(updateStickyCart, 10000);
})();

/* ============================================
   Shop Sort Select — change triggers page reload with sort param
   ============================================ */
(function() {
  var sortSelect = document.querySelector('.gs-sort-select, select[name="sort_by"], #sort-select');
  if (!sortSelect) return;

  sortSelect.addEventListener('change', function() {
    var sortValue = this.value;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    window.location.href = url.toString();
  });

  // Set current sort value from URL on page load
  var urlParams = new URLSearchParams(window.location.search);
  var currentSort = urlParams.get('sort_by');
  if (currentSort && sortSelect) {
    sortSelect.value = currentSort;
  }
})();

/* ============================================
   Shop Filter Tabs — fetch products by collection
   ============================================ */
(function() {
  /* escapeHtml() and formatJsonPrice() used to live here to build product
     cards by hand from /products.json. The server now renders the cards, so
     both are gone - formatJsonPrice in particular existed only to strip and
     re-add currency symbols, which is the bug class this replaces. */
  var filterBtns = document.querySelectorAll('.gs-filter-btn');
  var productGrid = document.querySelector('.product-grid, .gs-product-grid');
  var gridSectionEl = document.querySelector('[data-gs-grid-section]');
  var gridSectionId = gridSectionEl ? gridSectionEl.getAttribute('data-gs-grid-section') : '';

  /* Without a section id there is nothing safe to re-render, so leave the
     server-rendered grid alone rather than degrading to a broken filter. */
  if (!filterBtns.length || !productGrid || !gridSectionId) return;

  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      filterBtns.forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');

      var handle = this.dataset.collection;
      /* gsRoot() is trailing-slashed, so no leading slash here. Same reason as
         the sticky cart: a bare '/collections/...' would drop the market. */
      var base = gsRoot() + 'collections/' + encodeURIComponent(handle === 'all' ? 'all' : handle);

      /* Section Rendering API, not /products.json. products.json returns
         prices as base-currency strings with no conversion, so cards built
         from it were wrong in every non-EUR market AND had a hardcoded euro
         sign. Re-rendering the section server-side means the cards come from
         gs-product-card.liquid with `money` prices in the active market's
         currency - identical markup to first paint, by construction.

         Sorting is untouched: it is a full page reload (see the Shop Sort
         Select block above), never this path. */
      var url = base + '?sections=' + encodeURIComponent(gridSectionId);

      fetch(url)
        .then(function(r) {
          if (!r.ok) throw new Error('section render failed');
          return r.json();
        })
        .then(function(data) {
          var html = data[gridSectionId];
          if (!html) throw new Error('section missing from response');

          var parsed = new DOMParser().parseFromString(
            gsSectionInner(html, gridSectionId), 'text/html'
          );
          var newGrid = parsed.querySelector('.product-grid, .gs-product-grid');

          if (newGrid) {
            productGrid.innerHTML = newGrid.innerHTML;
          } else {
            var emptyState = parsed.querySelector('.gs-empty-state');
            productGrid.innerHTML = emptyState
              ? emptyState.outerHTML
              : '<div class="gs-empty-state" style="text-align:center;padding:3rem;color:#888;grid-column:1/-1;">Nothing here yet.</div>';
          }
          if (window.gsInitImageFade) window.gsInitImageFade();
        })
        .catch(function() {
          productGrid.innerHTML = '<div class="gs-empty-state" style="text-align:center;padding:3rem;color:#888;grid-column:1/-1;">Nothing here yet.</div>';
        });
    });
  });
})();

/* ============================================
   Announcement Bar — Rotating Messages
   One message at a time, hard-guaranteed:
   - double-init guard (script can never rotate twice in parallel)
   - swap only while fully faded out; skipped in background tabs
     (timer coalescing there caused mid-fade swaps)
   - any duplicate text nodes (apps/editor) are removed before writing
   ============================================ */
(function() {
  var messages = [
    'CE LEVEL 2 ARMOUR — WORN BY 1,000+ RIDERS',
    'ARAMID REINFORCED — INVISIBLE ARMOUR FOR EVERYDAY RIDING',
    '14-DAY RETURNS — 14 DAYS FROM DELIVERY'
  ];
  var el = document.getElementById('gs-announce-text');
  if (!el || el.dataset.gsRotating) return;
  el.dataset.gsRotating = '1';

  // Belt & braces: if anything ever duplicated the text span, drop extras.
  document.querySelectorAll('.announcement-text').forEach(function(node) {
    if (node !== el) node.parentNode.removeChild(node);
  });

  var i = 0;
  var swapping = false;

  function rotate() {
    if (swapping || document.hidden) return; // never overlap swaps; pause when tab hidden
    swapping = true;
    el.style.opacity = '0';
    setTimeout(function() {
      i = (i + 1) % messages.length;
      el.textContent = messages[i]; // atomic replace — single text node
      el.style.opacity = '1';
      swapping = false;
    }, 350);
  }

  setInterval(rotate, 4000);
})();

/* ============================================
   Scroll Reveal Animations
   ============================================ */
(function() {
  function initScrollReveal() {
    var elements = document.querySelectorAll(
      '.product-card, .review-card, .trust-large-card, .gs-culture-val-card, .gs-prot-card, .gs-shipping-card, .section-header, .gs-about-val, .faq-item'
    );

    if (GS_REDUCED_MOTION) return; // leave elements fully visible, no reveal classes

    elements.forEach(function(el) {
      el.classList.add('gs-fade-in');
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function(el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }
})();

/* ============================================
   Product Page — shared interactivity
   (hoodie + gloves sections; behavior that needs
   no Liquid data lives here, not in the sections)
   ============================================ */
(function() {
  function initProductPage() {
    var form = document.getElementById('gs-product-form');
    if (!form) return;

    /* --- Quantity stepper --- */
    var qtyInput = document.getElementById('gs-qty');
    var qtyMinus = document.getElementById('gs-qty-minus');
    var qtyPlus = document.getElementById('gs-qty-plus');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      qtyPlus.addEventListener('click', function() {
        qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
      });
    }

    /* --- Thumbnail switching with cross-fade --- */
    var mainImg = document.getElementById('gs-featured-img');
    document.querySelectorAll('.gs-thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (mainImg) window.gsSwapImage(mainImg, this.dataset.src);
        document.querySelectorAll('.gs-thumb').forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });

    /* --- Click-to-zoom on the main image --- */
    if (mainImg) {
      var imgWrap = mainImg.closest('.gs-main-image');
      if (imgWrap) {
        imgWrap.classList.add('gs-zoomable');
        imgWrap.addEventListener('click', function(e) {
          var zoomed = imgWrap.classList.toggle('gs-zoomed');
          if (zoomed) {
            var rect = imgWrap.getBoundingClientRect();
            var x = ((e.clientX - rect.left) / rect.width) * 100;
            var y = ((e.clientY - rect.top) / rect.height) * 100;
            mainImg.style.transformOrigin = x + '% ' + y + '%';
          } else {
            mainImg.style.transformOrigin = '';
          }
        });
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            imgWrap.classList.remove('gs-zoomed');
            mainImg.style.transformOrigin = '';
          }
        });
      }
    }

    /* --- AJAX add-to-cart with loading / confirmation state --- */
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var addBtn = document.getElementById('gs-add-to-cart');
      if (!addBtn || addBtn.disabled) return;

      var originalHTML = addBtn.innerHTML;
      addBtn.disabled = true;
      addBtn.classList.add('gs-btn-loading');
      addBtn.innerHTML = '<span class="gs-btn-spinner" aria-hidden="true"></span> Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function(r) {
          if (!r.ok) throw new Error('add-to-cart failed');
          return r.json();
        })
        .then(function() {
          addBtn.classList.remove('gs-btn-loading');
          addBtn.classList.add('gs-btn-added');
          addBtn.innerHTML = '✓ Added to Cart';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function() {
            addBtn.classList.remove('gs-btn-added');
            addBtn.innerHTML = originalHTML;
            addBtn.disabled = false;
          }, 2000);
        })
        .catch(function() {
          // Fall back to a native submit so the sale isn't lost.
          // form.submit() does not re-trigger this submit handler.
          addBtn.classList.remove('gs-btn-loading');
          addBtn.innerHTML = originalHTML;
          addBtn.disabled = false;
          form.submit();
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }
})();


/* ============================================================
   BACK IN STOCK (Klaviyo) — notify-me capture
   ------------------------------------------------------------
   Posts to Klaviyo's CLIENT back-in-stock endpoint, which is built for
   browser use and takes the PUBLIC key only. Contract (verified against
   Klaviyo's API reference, not guessed):

     POST https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=<public key>
     Content-Type: application/vnd.api+json      <- NOT application/json
     revision:     2026-07-15
     -> 202 Accepted on success (no body)

   The variant id is Klaviyo's catalog id, not the bare Shopify id:
     $shopify:::$default:::<variant_id>

   There is no retry. A back-in-stock signup is not worth hammering a third
   party for, and a duplicate signup on a flaky connection is worse than a
   "try again" — the shopper can just resubmit.

   The form is server-rendered for every variant and hidden with [hidden];
   setVariant() only flips that attribute, so switching size costs nothing.
   ============================================================ */
(function () {
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var REVISION = '2026-07-15';

  function say(box, text, state) {
    if (!box) return;
    box.textContent = text;
    box.classList.remove('is-ok', 'is-error');
    if (state) box.classList.add(state);
  }

  /* Deliberately loose. The browser's type="email" check plus Klaviyo's own
     validation are the real gates; a strict regex here only ever rejects
     addresses that are in fact valid. */
  function looksLikeEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function subscribe(key, variantId, email) {
    return fetch(ENDPOINT + '?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: { type: 'profile', attributes: { email: email } }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId
              }
            }
          }
        }
      })
    });
  }

  function initBackInStock() {
    document.querySelectorAll('[data-gs-bis]').forEach(function (box) {
      var form = box.querySelector('[data-gs-bis-form]');
      var msg = box.querySelector('[data-gs-bis-msg]');
      if (!form) return;

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var input = form.querySelector('input[type="email"]');
        var button = form.querySelector('button[type="submit"]');
        var email = input ? input.value.trim() : '';
        var key = box.dataset.gsBisKey;
        var variantId = box.dataset.gsBisVariant;

        if (!looksLikeEmail(email)) {
          say(msg, 'Enter a valid email address.', 'is-error');
          if (input) input.focus();
          return;
        }
        if (!key || !variantId) {
          say(msg, 'Notifications are not configured yet.', 'is-error');
          return;
        }
        if (button && button.disabled) return;

        if (button) button.disabled = true;
        say(msg, 'Signing you up...', null);

        subscribe(key, variantId, email)
          .then(function (response) {
            if (response.ok) {
              form.reset();
              say(msg, box.dataset.gsBisSuccess ||
                "Done - we'll email you the moment it's back.", 'is-ok');
            } else {
              say(msg, "That didn't go through. Please try again.", 'is-error');
            }
          })
          .catch(function () {
            /* Network/CORS/offline. Same user-facing message: the shopper can
               do nothing about the distinction. */
            say(msg, "That didn't go through. Please try again.", 'is-error');
          })
          .then(function () {
            if (button) button.disabled = false;
          });
      });
    });
  }

  /* Called by the product sections' variant switcher. Keeping the DOM lookup
     here (rather than caching a node) means it survives a section re-render
     from the Section Rendering API. */
  window.gsBackInStock = {
    setVariant: function (variantId, available) {
      document.querySelectorAll('[data-gs-bis]').forEach(function (box) {
        box.dataset.gsBisVariant = variantId;
        var msg = box.querySelector('[data-gs-bis-msg]');
        if (msg) say(msg, '', null);
        if (available) {
          box.setAttribute('hidden', '');
        } else {
          box.removeAttribute('hidden');
        }
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackInStock);
  } else {
    initBackInStock();
  }
})();
